"use client";

import { useClientConfigProvider } from "@/app/config/client-config-provider";
import AppRoutes from "@/app/constants/routes";
import { useMixPanel } from "@/app/context/mixPanelContext";
import ToastUtils from "@/app/toast/toast-utils";
import CustomButtonV2 from "@/app/versioning/components/v2/CustomButton/CustomButtonV2";

import { useAppContext } from "@thriwe-2-0/thriwe-ui-utils";
import { t } from "i18next";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { ChangeEvent, useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { IoCloseCircle } from "react-icons/io5";

const WriteToUsModalV2 = ({
  isOpen,
  handleClose,
  data,
  bookingDetail,
}: {
  isOpen: boolean;
  handleClose: () => void;
  data?: string[];
  bookingDetail?: any;
}) => {
  const { trackEvent } = useMixPanel();
  const {
    state: { user, memberships, selectedMembership },
    instances: { apiRepository },
    setUser,
    fetchUserProfile,
  } = useAppContext();

  const { getImagePath } = useClientConfigProvider();
  const [loading, setLoading] = useState<boolean>();
  const [feedback, setFeedback] = useState<string>("");
  const [showFeedbackMessage, setshowFeedbackMessage] =
    useState<boolean>(false);
  const postPlatformFeedback = () => {
    setLoading(true);

    apiRepository
      ?.openFeedback({
        feedback,
        platform_code: process.env.NEXT_PUBLIC_PROJECT_CODE,
      })
      .then((v) => {
        console.log("res", v);
        setFeedback("");
        setLoading(false);
        setshowFeedbackMessage(true);
        setTimeout(() => {
          setshowFeedbackMessage(false);
          handleClose();
        }, 2000);
      })
      .catch((error) => {
        setLoading(false);
        ToastUtils.showErrorToast(
          error?.data?.message ?? "Something went wrong!!"
        );
        console.log("error", error);
      });
  };

  return (
    <Modal
      zIndex={""}
      centered
      isOpen={isOpen}
      toggle={handleClose}
      contentClassName="write-to-us-modal-v2"
    >
      <div className="write-query_modal_container-v2">
        <div className="query_modal_header">
          <div>{t("support.writeToUs")}</div>
          <IoCloseCircle
            onClick={() => {
              handleClose();
            }}
            size={30}
            color="var(--color-grayscale-border-default)"
          />
        </div>
        <div className="query-container">
          <div>{t("support.sendUsQuery")}</div>
          <textarea
            style={{ minHeight: "50px" }}
            onChange={(e) => {
              console.log(feedback);
              setFeedback(e?.target.value);
            }}
            value={feedback}
            rows={3}
            cols={50}
            className="text-input"
            placeholder="Write your message"
          />
        </div>
        {showFeedbackMessage ? (
          <div className="success-message-alert">
            {t("feedbackNQueries.querySubmitted")}
          </div>
        ) : (
          <CustomButtonV2
            isLoading={loading}
            onClick={() => {
              postPlatformFeedback();
            }}
          >
            {t("common.send")}
          </CustomButtonV2>
        )}
      </div>
    </Modal>
  );
};

export default WriteToUsModalV2;
